// store/store.js
import { configureStore } from "@reduxjs/toolkit";
import learningJourneyReducer from "./Redux/learningJourneySlice";
import AuthReducer from "./Redux/AuthSlice";
import useDashboardReducer from "./Redux/page-slices/dashboardSlice";
import useResourceReducer from "./Redux/page-slices/resourcesSlice";
import useLessonReducer from "./Redux/page-slices/lessonsSlice";
import useReportReducer from "./Redux/page-slices/weeklyReportSlice";
import useFitbitReducer from "./Redux/page-slices/fitbitSlice";

export const store = configureStore({
  reducer: {
    Auth: AuthReducer,
    learningJourney: learningJourneyReducer,
    dashboard: useDashboardReducer,
    resources: useResourceReducer,
    lessons: useLessonReducer,
    reports: useReportReducer,
    fitbit: useFitbitReducer,
  },
  // Redux Toolkit automatically includes thunk by default
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
